import { useEffect, useState } from "react";
import axios from "axios";
import { getCurrentLanguage } from "@root/store/selectors/features";
import { useSelector } from "react-redux";

export const useCountry = () => {
  const [country, setCountry] = useState<any>(null);
  const [isLoading, setIsLoading] = useState<any>(null);
  const [OS, SetOS] = useState<any>(null);
  const [browser, SetBrowser] = useState<any>(null);
  const currentLanguage = useSelector(getCurrentLanguage);

  const detectOS = (): string => {
    const userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.includes("windows")) return "Windows";
    if (userAgent.includes("mac")) return "MacOS";
    if (userAgent.includes("android")) return "Android";
    if (userAgent.includes("iphone") || userAgent.includes("ipad"))
      return "iOS";
    if (userAgent.includes("linux")) return "Linux";
    return "Unknown";
  };

  const detectBrowser = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    let browser = "Unknown";
    if (userAgent.includes("chrome") && !userAgent.includes("edg"))
      browser = "Chrome";
    else if (userAgent.includes("firefox")) browser = "Firefox";
    else if (userAgent.includes("safari") && !userAgent.includes("chrome"))
      browser = "Safari";
    else if (userAgent.includes("edge") || userAgent.includes("edg"))
      browser = "Edge";
    else if (userAgent.includes("opera") || userAgent.includes("opr"))
      browser = "Opera";
    return browser;
  };

  useEffect(() => {
    const fetchCountry = async () => {
      try {
        setIsLoading(true);
        const response = await axios.get("https://geolocation-db.com/json/");
        setCountry(response?.data);
        SetOS(detectOS());
        SetBrowser(detectBrowser());
      } catch (err) {
      } finally {
        setIsLoading(false);
      }
    };

    fetchCountry();
  }, []);

  return { country, isLoading, currentLanguage, OS, browser };
};
